import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["focus"]
  static values = {
    id: String,
  };

  connect() {
    this.focusTarget.focus()
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("mousedown", this.boundHandleClickOutside)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener("mousedown", this.boundHandleClickOutside)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  handleClickOutside(event) {
    if (!this.focusTarget.contains(event.target)) {
      this.hide(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hide(event)
    }
  }

  hide(event) {
    event.preventDefault()
    this.element.remove()
  }

  hideOnSubmit(event) {
    if (event.detail.success) {
      this.hide(event)
    }
  }
}
